import {
  findLastTermocontraccionPrimeroDelParcialId23Task,
  findPrimeroDelParcialId23Task,
  MedicionesParcialId23,
  normalizeMedicionesParcialId23,
  shouldUseMedicionesParcialId23,
} from 'src/modules/tarea/medicionesParcialId23';
import {
  findPrimeroDelParcialId24Task,
  MedicionesParcialId24,
  normalizeMedicionesParcialId24,
  shouldUseMedicionesParcialId24,
} from 'src/modules/tarea/medicionesParcialId24';

export type MedicionesParcialDisplay =
  | {kind: 'id23'; values: MedicionesParcialId23}
  | {kind: 'id24'; values: MedicionesParcialId24}
  | {kind: null; values: null};

export const resolveMedicionesParcialForDisplay = (
  tasks: any[] = [],
  tenantId?: string | null,
): MedicionesParcialDisplay => {
  const primero23 = findPrimeroDelParcialId23Task(tasks);
  const primero24 = findPrimeroDelParcialId24Task(tasks);
  const show23 = Boolean(
    primero23 &&
      shouldUseMedicionesParcialId23({
        tenantId,
        modeloTareaTitulo: primero23?.modeloTarea?.titulo || primero23?.tituloTarea || primero23?.titulo,
        primeroDelParcial: primero23?.primeroDelParcial,
      }),
  );
  const show24 = Boolean(
    !show23 &&
      primero24 &&
      shouldUseMedicionesParcialId24({
        tenantId,
        modeloTareaTitulo: primero24?.modeloTarea?.titulo || primero24?.tituloTarea || primero24?.titulo,
        primeroDelParcial: primero24?.primeroDelParcial,
      }),
  );

  if (show24) {
    return {kind: 'id24', values: normalizeMedicionesParcialId24(primero24?.medicionesParcial)};
  }

  if (show23) {
    const base = normalizeMedicionesParcialId23(primero23?.medicionesParcial);
    const termocontraccionTask = findLastTermocontraccionPrimeroDelParcialId23Task(tasks);
    const values = termocontraccionTask?.medicionesParcial
      ? {
          ...base,
          termocontraccion_t: termocontraccionTask.medicionesParcial.termocontraccion_t,
          termocontraccion_l: termocontraccionTask.medicionesParcial.termocontraccion_l,
          na_termocontraccion: termocontraccionTask.medicionesParcial.na_termocontraccion,
        }
      : base;
    return {kind: 'id23', values};
  }

  return {kind: null, values: null};
};
